export const API_BASE = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : "";

export const getJson = async (path) => {
  if (!API_BASE) throw new Error("API not configured");
  const res = await fetch(`${API_BASE}${path}`);
  if (!res.ok) throw new Error(`Request failed (${res.status})`);
  return res.json();
};

export const postJson = async (path, body) => {
  if (!API_BASE) throw new Error("API not configured");
  const res = await fetch(`${API_BASE}${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data?.detail === "string" ? data.detail : "Please check what you entered and try again.");
  return data;
};

const errorText = (status, data) => {
  if (status === 429) return data?.detail || "Daily limit reached. Please try again tomorrow.";
  if (status === 422) return "Please check what you typed and try again.";
  return "Something went wrong. Please try again.";
};

// POSTs and streams SSE tokens to onToken. Resolves with the full text.
export const streamPost = async (path, body, onToken) => {
  if (!API_BASE) throw new Error("This feature isn't available right now.");
  const res = await fetch(`${API_BASE}${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!res.ok || !res.body) throw new Error(errorText(res.status, await res.json().catch(() => ({}))));
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let full = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop() ?? "";
    for (const ev of events) {
      const line = ev.trim();
      if (!line.startsWith("data:")) continue;
      const msg = JSON.parse(line.slice(5));
      if (msg.error) throw new Error(msg.error);
      if (msg.t) {
        full += msg.t;
        onToken(full);
      }
    }
  }
  return full;
};
